module.exports = __webpack_public_path__ + "static/media/stop-win.a0919d97.svg";